import cadres from "./modules/serviceCache"


const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,

  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,

  token: state => state.user.token,
  menus: state=>state.user.menus,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  orgName:state=>state.user.userInfo.organization.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  userinfo:state=>state.user.userInfo,

  cadres:state=>state.serviceCache.cadrelist,
  itemTree:state=> state.serviceCache.itemTree,
  dictionary:state=>state.serviceCache.dictionary
  // permission_routes: state => state.permission.routes,
  // errorLogs: state => state.errorLog.logs
}
export default getters
